<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>Log In</v-card-title>
          <v-card-text>
            <v-text-field label="Email" v-model="email"></v-text-field>
            <v-text-field label="Password" type="password" v-model="password"></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" rounded @click="login()">Log In</v-btn>
            <v-btn color="primary" rounded outlined to="/register">Register</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";
import firebase from "firebase";
export default {
  data() {
    return {
      email: "",
      password: ""
    };
  },
  methods: {
    ...mapMutations(["setUser"]),
    login() {
      const self = this;
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          function(response) {
            self.setUser(response.user);
            self.$router.push("/");
          },
          function(err) {
            alert("Something went wrong" + err.message);
          }
        );
    }
  }
};
</script>

<style lang="scss" scoped></style>
